import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/de';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.locale("de");

export default dayjs;
